var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#4794EF",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m2 2 6 6m10-6-6 6M8 8l.586.586a2 2 0 0 0 2.828 0L12 8M8 8l-6.121 6.121M12 8l6.121 6.121m0 0A3 3 0 0 0 19 12V3a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v9c0 .828.336 1.578.879 2.121m16.242 0A3 3 0 0 1 16 15H4a3 3 0 0 1-2.121-.879"
  })));
};
export default SvgMail;